import { LOGO_URL } from "@/constants";
import Image from "next/image";
import Link from "next/link";
import React from "react";

interface SLogoProps {
  locale?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export default function SLogo({ locale, onClick }: SLogoProps) {
  return (
    <Link href={`/${locale ?? ""}`} onClick={onClick}>
      <div className="inline-flex items-center">
        <Image
          className="object-contain cursor-pointer h-8 w-auto sm:h-10"
          src={LOGO_URL}
          width={180}
          height={40}
          sizes="(max-width: 640px) 128px, 160px"
          priority={true}
          alt="snapbox-logo"
        />
      </div>
    </Link>
  );
}
